var createECDH = require('crypto').createECDH

module.exports = createECDH || require('./browser')



//////////////////
// WEBPACK FOOTER
// ./~/create-ecdh/index.js
// module id = 873
// module chunks = 0 1 2 3